import "./Inputs.css";
const hasAffix = "Inputs_hasAffix_bc12b";
const css = {
  hasAffix
};
export {
  css as c
};
